/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Ukm_A2dInputs */

const en_mk_sol_ukm_a2d = /** @type {(inputs: Mk_Sol_Ukm_A2dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drafts replies to complaints and customer questions using the order data on hand.`)
};

const id_mk_sol_ukm_a2d = /** @type {(inputs: Mk_Sol_Ukm_A2dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menyiapkan balasan komplain dan pertanyaan pelanggan memakai data pesanan yang ada.`)
};

/**
* | output |
* | --- |
* | "Drafts replies to complaints and customer questions using the order data on hand." |
*
* @param {Mk_Sol_Ukm_A2dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_ukm_a2d = /** @type {((inputs?: Mk_Sol_Ukm_A2dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Ukm_A2dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_ukm_a2d(inputs)
	return en_mk_sol_ukm_a2d(inputs)
});